import React from 'react'
import { Field } from 'redux-form';

import { InputPicker, DinamicComponents, Item, painel } from 'scorpion-core'
import GantComponent from './components/GantComponent'
import EditorSeletor from '../../editor/SeletorUidCustomForm'

import EditorCodigo from '../../editor/EditorCodigo'
function componentRelEspelho(comp, dados) {
    return ""
}

function component(item, propsview) {
    let funcFiltro = null;
    try {
        funcFiltro = new Function("return " + item.filtro)();
    } catch (error) {
    }
    return (<Item key={item.sha} style={{ flex: 1 }}>
        <GantComponent item={item}  propsview={propsview} funcFiltro={funcFiltro} />
        {/* <Field name={item.field} item={item} component={GantComponent} /> */}
    </Item>)

}

const modelo = {
    typeComponente: "GantListaFiltrada",    
    label: "GantListaFiltrada",
    customFormUid: "",
    filtro: `function atendeFiltro(obj){
         console.log("obj1",obj); 
         return false; 
        }`,
}

const comp = {
    typeComponente: "GantListaFiltrada",
    configView: {
        nome: "GantListaFiltrada",
        modelo,
        editores: {
            customFormUid: EditorSeletor,
            filtro: EditorCodigo,
        },
    },
    componentRelEspelho,
    component,

}

export default comp;


// WEBPACK FOOTER //
// ./src/routes/sistema/DinamicComponenets/components/GantListaFiltrada/index.js